<template>
  <div class="headerTwo cg-mainWrapper">
    <div class="cgr-header-pc">
      <router-link to="/" class="cgr-logo fl">
        <img src="/static/img/logo.png" alt="">
      </router-link>
      <div class="cgr-link-nav fl">
        <router-link to="/" exact="">HOME</router-link>
        <router-link to="/podcast">SHOWS & PODCASTS</router-link>
        <router-link to="/francais">Français</router-link>
        <!-- <router-link to="/special">SPECIAL</router-link> -->
      </div>
      <div class="cgr-info-nav fr">
        <!-- <a href="https://www.facebook.com/CGTNradio" class="facebook" title="facebook" target="_blank"></a> -->
        <a href="https://x.com/cgtnradio" class="twitter" ref="headerShareTwitter" title="twitter" target="_blank"></a>
        <a href="https://www.youtube.com/@CGTNPodcasts" class="youtube" ref="headerShareYoutube" title="youtube" target="_blank"></a>
        <a href="javascript:;" class="email" title="email" @click="sendEmail"></a>
      </div>
    </div>
    <div class="cgr-header-pad">
      <div class="cgr-info-nav fl">
        <!-- <a href="https://www.facebook.com/CGTNradio" class="facebook" title="facebook" target="_blank"></a> -->
        <a href="https://x.com/cgtnradio" class="twitter" ref="headerShareTwitter" title="twitter" target="_blank"></a>
        <a href="https://www.youtube.com/@CGTNPodcasts" class="youtube" ref="headerShareYoutube" title="youtube" target="_blank"></a>
        <a href="javascript:;" class="email" title="email" @click="sendEmail"></a>
      </div>
      <router-link to="/" class="cgr-logo">
        <img src="/static/img/logo.png" alt="">
      </router-link>
      <div class="cgr-link-nav fr">
        <router-link to="/" exact="">HOME</router-link>
        <router-link to="/podcast">SHOWS & PODCASTS</router-link>
        <router-link to="/francais">Français</router-link>
        <!-- <router-link to="/special">SPECIAL</router-link> -->
      </div>
    </div>
    <div class="cgr-header-m">
      <div class="cgr-logo-con">
        <router-link to="/" class="cgr-logo">
          <img src="/static/img/logo.png" alt="">
        </router-link>
      </div>
      <div class="cgr-nav-con">
        <div class="cgr-link-nav fl">
          <router-link to="/" exact="">HOME</router-link>
          <router-link to="/podcast">SHOWS & PODCASTS</router-link>
          <router-link to="/francais">Français</router-link>
          <!-- <router-link to="/special">SPECIAL</router-link> -->
        </div>
        <div class="cgr-info-nav fr">
          <!-- <a href="https://www.facebook.com/CGTNradio" class="facebook" title="facebook" target="_blank"></a> -->
          <a href="https://x.com/cgtnradio" class="twitter" ref="headerShareTwitter" title="twitter" target="_blank"></a>
          <a href="https://www.youtube.com/@CGTNPodcasts" class="youtube" ref="headerShareYoutube" title="youtube" target="_blank"></a>
          <a href="javascript:;" class="email" title="email" @click="sendEmail"></a>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderTwo",
  data() {
    return {
      msg: "header",
    };
  },
  methods:{
    sendEmail:function(){  //发送本页地址到邮箱
      var _href = window.location.href;
      window.location.href = 'mailto:radio@cgtn.com?subject=Radio - CGTN&body='+_href+'';
    },
  },
  created(){

  },
  mounted(){
    
  }
};
</script>

<style scoped lang="scss">
.cgr-info-nav{
  a{
    &.facebook{
      background: url('/static/img/share-facebook-icon.png') no-repeat;
      background-size: 100% 100%;
    }
    &.twitter{
      background: url('/static/img/share-twitter-icon.png') no-repeat;
      background-size: 100% 100%;
    }
    &.email{
      background: url('/static/img/share-email-icon.png') no-repeat;
      background-size: 100% 100%;
    }
    &.youtube{
      background: url('/static/img/share-youtube-icon.png') no-repeat;
      background-size: 100% 100%;
    }
  }
}
.cgr-header-pc{
  height: 100px;
  .cgr-logo{
    width: 214px;
    height: 49px;
    overflow: hidden;
    margin-top: 25.5px;
  }
  .cgr-link-nav{
    margin-top: 45.5px;
    a{
      float: left;
      font-size: 16px;
      height: 11px;
      border-left: 10px solid #bfae61;
      padding-left: 3px;
      color: #999999;
      font-family: HelveticaLTPro-Bold;
      box-sizing: border-box;
      &.active , &:hover{
        color: #333333;
      }
      &:first-child{
        margin-left: 0;
      }
    }
  }
  .cgr-info-nav{
    margin-top: 37.5px;
    a{
      float: left;
      width: 25px;
      height: 25px;
      &:first-child{
        margin-left: 0;
      }
    }
  }
}
.cgr-header-pad{
  display: none;
}
.cgr-header-m{
  display: none;
}
@media screen and (min-width: 1561px) {
  .cgr-header-pc{
    padding: 0 30px;
    .cgr-link-nav{
      margin-left: 86px;
      a{
        margin-left: 40px;
      }
    }
    .cgr-info-nav{
      a{
        margin-left: 50px;
      }
    }
  }
}
@media screen and (min-width: 1261px) and (max-width: 1560px) {
  .cgr-header-pc{
    padding: 0 30px 0 50px;
    .cgr-link-nav{
      margin-left: 100px;
      a{
        margin-left: 40px;
      }
    }
    .cgr-info-nav{
      a{
        margin-left: 23px;
      }
    }
  }
}
@media screen and (min-width: 769px) and (max-width: 1260px) {
  .cgr-header-pc{
    display: none;
  }
  .headerTwo.cg-mainWrapper{
    width: 100% !important;
  }
  .cgr-header-pad{
    display: block;
    position: relative;
    width: 100%;
    height: 70px;
    padding: 0 10px 0 30px;
    .cgr-logo{
      width: 159px;
      height: 36px;
      overflow: hidden;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
    }
    .cgr-info-nav{
      margin-top: 25px;
      a{
        float: left;
        width: 20px;
        height: 20px;
        margin-left: 24px;
        &:first-child{
          margin-left: 0;
        }
      }
    }
    .cgr-link-nav{
      margin-top: 29px;
      a{
        float: left;
        font-size: 10px;
        height: 12px;
        line-height: 14px;
        border-left: 7px solid #bfae61;
        padding-left: 3px;
        color: #999999;
        font-family: HelveticaLTPro-Bold;
        box-sizing: border-box;
        margin-left: 20px;
        &.active , &:hover{
          color: #333333;
        }
        &:first-child{
          margin-left: 0;
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .cgr-header-pc{
    display: none;
  }
  .cgr-header-pad{
    display: none;
  }
  .cgr-header-m{
    display: block;
    width: 100%;
    .cgr-logo-con{
      height: 70px;
      overflow: hidden;
      border-bottom: 1px solid #dddddd;
      .cgr-logo{
        width: 128px;
        height: 29px;
        display: block;
        margin: 20.5px auto 0;
      }
    }
    .cgr-nav-con{
      height: 1.67rem;
      padding: 0 1.28rem;
      .cgr-link-nav{
        margin-top: .5rem;
        a{
          float: left;
          font-size: .78rem;
          height: .67rem;
          border-left: .39rem solid #bfae61;
          padding-left: 1px;
          color: #999999;
          font-family: HelveticaLTPro-Bold;
          box-sizing: border-box;
          margin-left: 1rem;
          line-height: .89rem;
          &.active , &:hover{
            color: #333333;
          }
          &:first-child{
            margin-left: 0;
          }
        }
      }
      .cgr-info-nav{
        margin-top: .39rem;
        a{
          float: left;
          width: .89rem;
          height: .89rem;
          margin-left: .8rem;
          &:first-child{
            margin-left: 0;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HeaderTwo.vue